import { render, staticRenderFns } from "./PackingCheck.vue?vue&type=template&id=f16ee9ca&scoped=true"
import script from "./PackingCheck.vue?vue&type=script&lang=js"
export * from "./PackingCheck.vue?vue&type=script&lang=js"
import style0 from "./PackingCheck.vue?vue&type=style&index=0&id=f16ee9ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16ee9ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f16ee9ca')) {
      api.createRecord('f16ee9ca', component.options)
    } else {
      api.reload('f16ee9ca', component.options)
    }
    module.hot.accept("./PackingCheck.vue?vue&type=template&id=f16ee9ca&scoped=true", function () {
      api.rerender('f16ee9ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/packaging/PackingCheck.vue"
export default component.exports